import React from 'react';
import PropTypes from 'prop-types';

import { humanizeNumber } from '../../../utils/format';

import TwoValueBar from './TwoValueBar/TwoValueBar';
import SingleValueAndLabelBars from './SingleValueBar/SingleValueAndLabelBars';
import BarChart from './BarChart/BarChart';
import NationalAverageBar from './NationalAverageBar/NationalAverageBar';

import MoneyIcon from './images/icon-dollar-sign.png';
import { ESRI_YEAR_DEFAULTS } from '../../../constants';

const IncomeCharts = ({
  colors,
  overview: { income, nationalIncome },
}) => (
  <section>
    <h2 className="section-group-title">
      <span>Income</span>
    </h2>

    <div>
      <TwoValueBar
        sectionTitle="Median Household Income"
        colors={colors}
        label1={ESRI_YEAR_DEFAULTS.currentYear}
        label2={ESRI_YEAR_DEFAULTS.projectedYear}
        value1={`$${humanizeNumber(income.medianIncomeCurrent)}`}
        value2={`$${humanizeNumber(income.medianIncomeProjection)}`}
        image={MoneyIcon}
      >
        <NationalAverageBar
          value1={`$${humanizeNumber(nationalIncome.medianIncomeCurrent)}`}
          value2={`$${humanizeNumber(nationalIncome.medianIncomeProjection)}`}
          text="National Median"
        />
      </TwoValueBar>

      <TwoValueBar
        sectionTitle="Average Household Income"
        colors={colors}
        label1={ESRI_YEAR_DEFAULTS.currentYear}
        label2={ESRI_YEAR_DEFAULTS.projectedYear}
        value1={`$${humanizeNumber(income.averageIncomeCurrent)}`}
        value2={`$${humanizeNumber(income.averageIncomeProjection)}`}
        image={MoneyIcon}
      >
        <NationalAverageBar
          value1={`$${humanizeNumber(nationalIncome.averageIncomeCurrent)}`}
          value2={`$${humanizeNumber(nationalIncome.averageIncomeProjection)}`}
          text="National Avg."
        />
      </TwoValueBar>
    </div>

    <div>
      <TwoValueBar
        sectionTitle="Per Capita Income"
        colors={colors}
        label1={ESRI_YEAR_DEFAULTS.currentYear}
        label2={ESRI_YEAR_DEFAULTS.projectedYear}
        value1={`$${humanizeNumber(income.perCapitaIncomeCurrent)}`}
        value2={`$${humanizeNumber(income.perCapitaIncomeProjection)}`}
        image={MoneyIcon}
      >
        <NationalAverageBar
          value1={`$${humanizeNumber(nationalIncome.perCapitaIncomeCurrent)}`}
          value2={`$${humanizeNumber(nationalIncome.perCapitaIncomeProjection)}`}
          text="National Per Capita"
        />
      </TwoValueBar>

      <SingleValueAndLabelBars
        sectionTitle="Income Growth"
        colors={colors}
        smallLabels
        data={[
          {
            label: 'Per Capita Income Annual Growth Rate',
            value: `${income.perCapitaIncomeGrowthRate}%`,
          }, {
            label: 'Median Household Income Annual Growth Rate',
            value: `${income.medianHouseholdIncomeGrowthRate}%`,
          },
        ]}
      />
    </div>

    <div>
      <BarChart
        sectionTitle="Household Income Distribution"
        colors={colors}
        name1={ESRI_YEAR_DEFAULTS.currentYear}
        name2={ESRI_YEAR_DEFAULTS.projectedYear}
        data={[
          {
            label: '0-$25K',
            value1: income.distribution25kCurrent,
            value2: income.distribution25kProjection,
          }, {
            label: '$25-$50K',
            value1: income.distribution50kCurrent,
            value2: income.distribution50kProjection,
          }, {
            label: '$50-$75K',
            value1: income.distribution75kCurrent,
            value2: income.distribution75kProjection,
          }, {
            label: '$75-$100K',
            value1: income.distribution100kCurrent,
            value2: income.distribution100kProjection,
          }, {
            label: '$100K +',
            value1: income.distribution100kPlusCurrent,
            value2: income.distribution100kPlusProjection,
          },
        ]}
      />
    </div>
  </section>
);

IncomeCharts.propTypes = {
  colors: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.object, PropTypes.string]))
  .isRequired,
  overview: PropTypes.object.isRequired,
};

export default IncomeCharts;



// WEBPACK FOOTER //
// ./src/components/Areas/AreaOverview/IncomeCharts.js